export default __webpack_public_path__ + "static/Sprint1_Welcome_3Pillars_DESKTOP-fd1fb2626cabaef00de41a10c52cb135.mp4";